import React, { useEffect } from 'react';
import { EntityFinancialInformationData } from '../../../components/Types';
import s from './forms.module.scss';
import { fiatCurrencies } from '../../../constants/fiatCurrencies';
import { AutoCompleteSelect, TextField, RadioButtons } from '../../../components/UILib';
import { useTheme } from '../../../contexts/ThemeContext';
import { AutoCompleteSelectDataType } from '../../../components/UILib/AutoCompleteSelect/AutoCompleteSelect';
interface FinancialInformationProps {
    financialInformation: EntityFinancialInformationData;
    setFinancialInformation: React.Dispatch<React.SetStateAction<EntityFinancialInformationData>>;
    invalidInputFields: string[];
}
const options = [{value: true, label: 'Yes'}, {value: false, label: 'No'}]
function FinancialInformation({financialInformation, setFinancialInformation, invalidInputFields}: FinancialInformationProps) {
    const { theme } = useTheme();
    const handleInputValueChange = (value: string, name: string) => {
      
        setFinancialInformation((prevState) => ({...prevState, [name]: value}))
    }
    const handleCurrencyValueChange = (selection: AutoCompleteSelectDataType, name: string) => {
     
        setFinancialInformation((prevState) => ({...prevState, [name]: selection.value}))
    }
    const onSelectionChange = (event: React.ChangeEvent<HTMLInputElement>, name: string) => {
     
        const value = event.target.value === 'true';
        setFinancialInformation((prevState) => ({...prevState, [name]: value}));
    }
    return (
        <div className={s.rightContainer}>
            <div className={s.formContainer}>
                <div className={s.row}>
                    <div className={s.inputSectionFull}>
                        <p className={theme === 'dark' ? s.darkFont : s.lightFont}>Enter the estimated annual income of the applicant. <sup>*</sup></p>
                        <div className={s.currencySelectContainer}>
                            <div className={s.currency}>
                                <AutoCompleteSelect
                                    optionList={fiatCurrencies}
                                    value={{value: financialInformation.income_currency, label: financialInformation.income_currency}}
                                    onChange={(e, value) => handleCurrencyValueChange(value, 'income_currency')}
                                    currency={true}
                                    errorText={invalidInputFields.includes("Estimated annual income currency")? 'Estimated annual income currency' : undefined}
                                />
                            </div>
                            <TextField
                                name="income"
                                value={financialInformation.income}
                                onChange={handleInputValueChange}
                                variant="xs"
                                type='number'
                                amount={true}
                                externalError={invalidInputFields.includes("Estimated annual income")}
                                error={invalidInputFields.includes("Estimated annual income") ? 'Please enter your estimated annual income.' : undefined}
                                leftElementClassName={s.currencySymbol}
                                leftElement={financialInformation.income_currency !== '' ? <span>{financialInformation.income_currency === 'CAD' || financialInformation.income_currency === 'USD' ? '$'
                                : financialInformation.income_currency === 'GBP' ? '£' : '€'}</span> : null}
                            />
                        </div>
                    </div>
                </div>
                <div className={s.row}>
                    <div className={s.inputSectionFull}>
                        <p className={theme === 'dark' ? s.darkFont : s.lightFont}>Enter the value of the liquid assets of the applicant. <sup>*</sup></p>
                        <div className={s.currencySelectContainer}>
                            <div className={s.currency}>
                                <AutoCompleteSelect
                                    optionList={fiatCurrencies}
                                    value={{value: financialInformation.liquid_asset_currency, label: financialInformation.liquid_asset_currency}}
                                    onChange={(e, value) => handleCurrencyValueChange(value, 'liquid_asset_currency')}
                                    currency={true}
                                    errorText={invalidInputFields.includes("Currency of the liquid assets")? 'Currency of the liquid assets' : undefined}
                                />
                            </div>
                            <TextField
                                name="liquid_asset_value"
                                value={financialInformation.liquid_asset_value}
                                onChange={handleInputValueChange}
                                variant="xs"
                                type='number'
                                amount={true}
                                externalError={invalidInputFields.includes("Value of the liquid assets")}
                                error={invalidInputFields.includes("Value of the liquid assets") ? 'Please enter the value of your liquid assets.' : undefined}
                                leftElementClassName={s.currencySymbol}
                                leftElement={financialInformation.liquid_asset_currency !== '' ? <span>{financialInformation.liquid_asset_currency === 'CAD' || financialInformation.liquid_asset_currency === 'USD' ? '$'
                                : financialInformation.liquid_asset_currency === 'GBP' ? '£' : '€'}</span> : null}
                            />
                        </div>
                    </div>
                </div>

                <div className={s.row}>
                    <div className={s.inputSectionFull}>
                        <p className={theme === 'dark' ? s.darkFont : s.lightFont}>Is the company an accredited investor or equivalent in the country of incorporation?</p>
                        <RadioButtons
                            width='100%'
                            optionList={options} 
                            onChange={(e) => onSelectionChange(e, 'is_accredited_investor')} 
                            value={financialInformation.is_accredited_investor}
                            containerStyle={{display: 'flex', justifyContent: 'flex-start', width: '100%'}}
                            radioContainerStyle={{
                                    width: '40%', 
                                    color: theme === 'dark' ? 'white' : 'black',
                                    margin: 0,
                                }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FinancialInformation;